import {recipientNeededIntent} from './recipientNeededIntent.js'
export const UNADDRESSED='__unaddressed__'
export const UNADDRESSED_SCHEMA='sr-artwork-unaddressed-v1'
// A user choice, never a claim that contact research found nobody.
export async function unaddressedDraftIntent({confirmed,...binding}){
 if(confirmed!==true)throw Error('Deliberately choose an unaddressed draft before saving.')
 return {...await recipientNeededIntent(binding),schema:UNADDRESSED_SCHEMA}
}
export function unaddressedCapability(value){
 const available=value?.unaddressedAvailable,capability=value?.capabilities?.unaddressed
 if(available===undefined&&capability===undefined)return false
 if(typeof available!=='boolean'||typeof capability!=='boolean'||available!==capability)throw Error('Unaddressed draft capability is incomplete. Refresh before saving.')
 return available
}
